function Background() {
  return <div className="bg-gradient"></div>;
}

export { Background };
